/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sent: NonNullable<unknown>, total: NonNullable<unknown>, date: NonNullable<unknown> }} Dropwinnerssentstate3Inputs */

const en_dropwinnerssentstate3 = /** @type {(inputs: Dropwinnerssentstate3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sent to ${i?.sent} of ${i?.total} winners · last ${i?.date}`)
};

const de_dropwinnerssentstate3 = /** @type {(inputs: Dropwinnerssentstate3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`An ${i?.sent} von ${i?.total} Gewinnern gesendet · zuletzt ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Sent to {sent} of {total} winners · last {date}" |
*
* @param {Dropwinnerssentstate3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwinnerssentstate3 = /** @type {((inputs: Dropwinnerssentstate3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwinnerssentstate3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwinnerssentstate3(inputs)
	return de_dropwinnerssentstate3(inputs)
});
export { dropwinnerssentstate3 as "dropWinnersSentState" }